// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__Ziso6","form-control--invalid":"Input_form-control--invalid__VmmTE"};